(function ($) {
    /* eslint-disable */


    $(window).resize(function() {
        clearTimeout(window.resizedFinished);
        window.resizedFinished = setTimeout(function () {
            $(window).trigger('stopResize');
        }, 250);
    });



    var $tableLg = $('#table-pro-list-lg');
    var tableLg = false;
    var $tableSm = $('#table-pro-list-sm');
    var tableSm = false;

    $(document).on( 'init.dt', function(e) {
        setLastVisibleCol();
    });



    $(window).on( 'stopResize', function(e) {
        tableLg.destroy();
        tableSm.destroy();
        tableInitLg();
        tableInitSm();
        tableLg.columns.adjust().draw();
        tableSm.columns.adjust().draw();
        setLastVisibleCol();
    });


    function tableInitLg() {
        tableLg = $tableLg.DataTable({
            "info": false,
            "lengthMenu": 14,
            "autoWidth": false,
            "columnDefs": [
                // Make only 1-st col sortable and -
                { "orderable": false, "targets": [ 1, 8, 9, 10, 11, 12,] },
                // Searching only in 2 col
                { "searchable": false, "targets": [ 0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, ] },
                { className: 'control-td', targets: 0 },
                // For responsive start
                { "data": "xz", "targets": 13, className: "min-desktopInf" },
                { "data": "monitor", "targets": 12, className: "min-desktopXl" },
                { "data": "mousepad", "targets": 11, className: "min-desktopLg" },
                { "data": "headset", "targets": 10, className: "min-desktopMd" },
                { "data": "keyboard", "targets": 9, className: "min-desktopSm" },
                { "data": "mouse & controller", "targets": 8, className: "min-desktopXs" },
                { "data": "X-axis eDPI", "targets": 7, className: "min-tabletXl" },
                { "data": "DPI", "targets": 6, className: "min-tabletLg" },
                { "data": "Scope Sens", "targets": 5, className: "min-tabletMd" },
                { "data": "Targeting Sens", "targets": 4, className: "min-tabletSm" },
                { "data": "Sens Y", "targets": 3, className: "min-tabletSm" },
                { "data": "Sens X", "targets": 2, className: "min-tabletSm" },
                // for responsive end
            ],
            responsive: {
                breakpoints: [
                    { name: 'desktopInf', width: Infinity },
                    { name: 'desktopXl', width: 1440 },
                    { name: 'desktopLg', width: 1380 },
                    { name: 'desktopMd', width: 1300 },
                    { name: 'desktopSm', width: 1240 },
                    { name: 'desktopXs', width: 1130 },
                    { name: 'tabletXl', width: 980 },
                    { name: 'tabletLg', width: 846 },
                    { name: 'tabletMd', width: 740 },
                    { name: 'tabletSm', width: 680 },
                    { name: 'mobileLg', width: 576 },
                    { name: 'mobileMd', width: 500 },
                ],
                details: {
                    display: $.fn.dataTable.Responsive.display.childRowImmediate,

                }
            },
            "pagingType": "full_numbers",
            "language": {
                "paginate": {
                    "previous": "Prev"
                }
            },
        });
    }

    function tableInitSm() {
        tableSm = $tableSm.DataTable({
            "info": false,
            "lengthMenu": 14,
            "autoWidth": false,
            "columnDefs": [
                // Make only 1-st col sortable and -
                { "orderable": false, "targets": [ 1, 6, 7, 8, 9, 10] },
                // Searching only in 2 col
                { "searchable": false, "targets": [ 0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, ] },
                { className: 'control-td', targets: 0 },

                // For responsive start
                { "data": "xz", "targets": 12, className: "min-desktopInf" },
                { "data": "resolution", "targets": 11, className: "min-desktopXl" },
                { "data": "monitor", "targets": 10, className: "min-desktopLg" },
                { "data": "headset", "targets": 9, className: "min-desktopMd" },
                { "data": "keyboard", "targets": 8, className: "min-desktopSm" },
                { "data": "mousepad", "targets": 7, className: "min-desktopXs" },
                { "data": "mouse & controller", "targets": 6, className: "min-tabletXl" },
                { "data": "eDPI", "targets": 5, className: "min-tabletLg" },
                { "data": "DPI", "targets": 4, className: "min-tabletMd" },
                { "data": "Zoom Sens, Sens", "targets": [3, 2], className: "min-tabletSm" },
                // for responsive end
            ],
            responsive: {
                breakpoints: [
                    { name: 'desktopInf', width: Infinity },
                    { name: 'desktopXl', width: 1400 },
                    { name: 'desktopLg', width: 1350 },
                    { name: 'desktopMd', width: 1220 },
                    { name: 'desktopSm', width: 1130 },
                    { name: 'desktopXs', width: 1050 },
                    { name: 'tabletXl', width: 990 },
                    { name: 'tabletLg', width: 860 },
                    { name: 'tabletMd', width: 690 },
                    { name: 'tabletSm', width: 650 },
                    { name: 'mobileLg', width: 600 },
                    { name: 'mobileMd', width: 500 },
                ],
                details: {
                    display: $.fn.dataTable.Responsive.display.childRowImmediate,

                }
            },
            "pagingType": "full_numbers",
            "language": {
                "paginate": {
                    "previous": "Prev"
                }
            },
        });
    }

    tableInitLg();
    tableInitSm();

    tableLg.columns.adjust().draw();
    tableSm.columns.adjust().draw();


    window.tableLg = tableLg;
    window.tableSm = tableSm;

    function setLastVisibleCol() {
        var $th = $('th', $('.dataTable'));
        var lastClass = 'last';
        $th.removeClass(lastClass);
        $th.filter(':visible').last().addClass(lastClass);
    }


    tableLg.on( 'responsive-resize', function ( e, datatable, columns ) {
        var count = columns.reduce( function (a,b) {
            return b === false ? a+1 : a;
        }, 0 );

        console.log( count +' column(s) are hidden' );
    });



})( jQuery );
